"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapFdrApp = exports.createComposeAppFn = void 0;
require("@hotelplan/libs.polyfills");
require("@hotelplan/libs.router-config");
const compose_1 = __importDefault(require("lodash/fp/compose"));
const app_1 = __importDefault(require("next/app"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const components_common_meta_modules_1 = require("@hotelplan/components.common.meta-modules");
const components_common_progress_bar_1 = require("@hotelplan/components.common.progress-bar");
const fdr_lib_apollo_client_1 = require("@hotelplan/fdr.lib.apollo.client");
const fdr_lib_context_lang_1 = require("@hotelplan/fdr.lib.context.lang");
const fdr_lib_context_request_1 = require("@hotelplan/fdr.lib.context.request");
const fdr_lib_i18n_lang_config_1 = require("@hotelplan/fdr.lib.i18n.lang-config");
const fdr_lib_i18n_with_lang_1 = require("@hotelplan/fdr.lib.i18n.with-lang");
const fdr_lib_ident_with_auth_1 = require("@hotelplan/fdr.lib.ident.with-auth");
const fdr_lib_meta_with_meta_1 = require("@hotelplan/fdr.lib.meta.with-meta");
const fdr_lib_trace_with_page_view_1 = require("@hotelplan/fdr.lib.trace.with-page-view");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
const libs_context_modals_1 = require("@hotelplan/libs.context.modals");
const libs_context_object_id_1 = require("@hotelplan/libs.context.object-id");
const libs_context_page_type_1 = require("@hotelplan/libs.context.page-type");
const fdr_lib_misc_open_graph_1 = require("@hotelplan/fdr.lib.misc.open-graph");
const libs_origin_1 = require("@hotelplan/libs.origin");
const fdr_lib_misc_preview_1 = require("@hotelplan/fdr.lib.misc.preview");
const fdr_lib_x_debug_x_debug_hook_1 = require("@hotelplan/fdr.lib.x-debug.x-debug-hook");
const defaultI18NextConfig = {
    i18n: {
        defaultLocale: fdr_lib_i18n_lang_config_1.languageDefault,
        locales: fdr_lib_i18n_lang_config_1.languageList,
        localeDetection: false,
    },
};
function createComposeAppFn(config) {
    const { 
    // vert props
    i18nextConfig = defaultI18NextConfig, endpointBasePath = `/api/auth`, metaOptions = {}, openGraphOptions = {}, authNextOptions = {}, } = config;
    return (0, compose_1.default)(libs_context_object_id_1.appWithObjectId, libs_context_page_type_1.appWithPageType, components_common_meta_modules_1.appWithMetaModules, libs_context_device_type_1.appWithDeviceType, (0, fdr_lib_i18n_with_lang_1.appWithI18Next)(i18nextConfig), (0, fdr_lib_ident_with_auth_1.appWithAuthNext)(Object.assign(Object.assign({}, authNextOptions), { endpointBasePath })), (0, fdr_lib_meta_with_meta_1.appWithMetaData)(metaOptions), (0, fdr_lib_context_lang_1.appWithLanguages)(), libs_origin_1.appWithOrigin, (0, fdr_lib_misc_open_graph_1.appWithOpenGraph)(openGraphOptions));
}
exports.createComposeAppFn = createComposeAppFn;
function SideEffectsComponent({ useSideEffects, pageProps, user, }) {
    useSideEffects({ pageProps, user });
    return null;
}
function bootstrapFdrApp(config) {
    const { theme, GlobalStyle, getLayoutComponent, apolloTypePolicies, apolloPossibleTypes = {}, useSideEffects = () => undefined } = config, compositionConfig = __rest(config, ["theme", "GlobalStyle", "getLayoutComponent", "apolloTypePolicies", "apolloPossibleTypes", "useSideEffects"]);
    const { openGraphOptions } = compositionConfig;
    if (!apolloTypePolicies) {
        console.warn(`Define "apolloTypePolicies" property for bootstraping app`);
    }
    function PageComponentWithContext({ Component, pageProps, err, apolloClient: documentApolloClient, }) {
        const user = (0, fdr_lib_ident_with_auth_1.usePagePropsAuth)(pageProps);
        const preview = (0, fdr_lib_misc_preview_1.usePagePropsPreview)(pageProps);
        const xDebug = (0, fdr_lib_x_debug_x_debug_hook_1.useXDebugPageProps)(pageProps);
        const apolloClient = (0, fdr_lib_apollo_client_1.usePagePropsApollo)(pageProps, {
            possibleTypes: apolloPossibleTypes,
            typePolicies: apolloTypePolicies,
            getAccessToken() {
                return user === null || user === void 0 ? void 0 : user.accessToken;
            },
            getXDebugSubgraph() {
                return xDebug;
            },
            getPreview() {
                return preview;
            },
        }, documentApolloClient);
        const requestContext = (0, fdr_lib_context_request_1.usePagePropsRequestContext)(pageProps);
        const layoutEl = getLayoutComponent({ pageProps, user });
        const contentEl = react_1.default.cloneElement(layoutEl, layoutEl.props, react_1.default.createElement(Component, Object.assign({}, pageProps, { err: err })));
        return (react_1.default.createElement(fdr_lib_apollo_client_1.ApolloProvider, { client: apolloClient },
            react_1.default.createElement(fdr_lib_context_request_1.RequestContextProvider, { initialContext: requestContext },
                react_1.default.createElement(SideEffectsComponent, { useSideEffects: useSideEffects, pageProps: pageProps, user: user }),
                react_1.default.createElement(fdr_lib_trace_with_page_view_1.AppWithPageViewComponent, { pageProps: pageProps, pageViewOptions: Object.assign(Object.assign({}, config.pageViewOptions), { version: config.version }) }, contentEl))));
    }
    class App extends app_1.default {
        render() {
            return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
                GlobalStyle ? react_1.default.createElement(GlobalStyle, null) : null,
                react_1.default.createElement(components_common_progress_bar_1.ProgressBar, null),
                react_1.default.createElement(libs_context_modals_1.ModalContextProvider, null,
                    react_1.default.createElement(libs_context_ios_scroll_block_1.IOSScrollBlockContextProvider, null,
                        react_1.default.createElement(PageComponentWithContext, Object.assign({}, this.props)),
                        (openGraphOptions === null || openGraphOptions === void 0 ? void 0 : openGraphOptions.enable) && react_1.default.createElement(fdr_lib_misc_open_graph_1.OpenGraphAutoConsume, null)))));
        }
    }
    return createComposeAppFn(compositionConfig)(App);
}
exports.bootstrapFdrApp = bootstrapFdrApp;
//# sourceMappingURL=client.js.map